export function extractFormFields<T extends Record<string, any>>(
  formData: T,
  fields: (keyof T)[],
): Partial<T> {
  return fields.reduce((acc, field) => {
    acc[field] = formData[field];
    return acc;
  }, {} as Partial<T>);
}
